import { createClient } from '@supabase/supabase-js';

// Replace 'your-legacy-jwt-secret' with the actual secret from your Supabase dashboard
const legacyJwtSecret = 'KgOvWDV4XwtqIak3pYjCFwG+GikJDfyH3qqBlgHUAQmiclYPVNxgbl/B0AEwK6Ukk09c2b4T7GzWpAnAklTHAQ=='; // Fill this in when ready

export const supabase = createClient(
    'https://zxvjqkrfvproyblrjcst.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4dmpxa3JmdnByb3libHJqY3N0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyODU0MTYsImV4cCI6MjA1ODg2MTQxNn0.OKhbVDZBzdAybrDDTJ-lhB90euEbTioNggjSVDK7uJU',
    {
        db: { schema: 'api' },
        auth: {
            autoRefreshToken: true,
            persistSession: true,
            detectSessionInUrl: true,
            // Optional: Add legacy JWT secret for testing (remove after debugging)
            global: {
                headers: {
                    'x-supabase-jwt-secret': legacyJwtSecret, // Add this line
                },
            },
        },
    }
);

export const supabaseServiceRole = createClient(
    'https://zxvjqkrfvproyblrjcst.supabase.co',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp4dmpxa3JmdnByb3libHJqY3N0Iiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0MzI4NTQxNiwiZXhwIjoyMDU4ODYxNDE2fQ.379pL_bcQd8Qon8oI0VfMxM2hGvMxeB6v0lumOFCtXo',
    {
        db: { schema: 'api' },
        auth: {
            autoRefreshToken: false,
            persistSession: false,
        },
    }
);